module.exports = __webpack_public_path__ + "img/vr2_banner_m.9ca88d51.jpg";